<app-orders-nav [activeMenuItem]="'giftcards'"></app-orders-nav>


<mat-card class="content-card">

  <h3>Gift Cards</h3>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="20px">
    <div>

      <div fxFlex></div>
      <button mat-raised-button color="primary" (click)="goToBrands()">Edit Brands</button>

    </div>

  </div>


  <app-mat-table-generator #table
                           tableName="giftCardsTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="multiselectEnabled()"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           (clearingFilters)="checkAllButton()"
                           [dialogRemoveText]="dialogRemoveText"
                           [saveFilters]=true


  >
  </app-mat-table-generator>
</mat-card>
